/**
 * Formatting utility functions
 */

import { VehicleInfo } from "../types";

/**
 * Formats a phone number to (xxx) xxx-xxxx format
 * @param {string} phoneNumber - The phone number to format
 * @returns {string|false} - The formatted phone number or false if invalid
 */
export const formatPhoneNumber = function (
  phoneNumber: string
): string | false {
  // Format phone number to (xxx) xxx-xxxx
  const phoneNumberPattern = /^\+?1?(\d{3})(\d{3})(\d{4})$/;
  if (phoneNumberPattern.test(phoneNumber)) {
    const formattedPhoneNumber = phoneNumber.replace(
      phoneNumberPattern,
      "($1) $2-$3"
    );
    return formattedPhoneNumber;
  } else {
    return false;
  }
};

/**
 * Extracts vehicle ID from vehicle object
 * @param {VehicleInfo} vehicle - The vehicle object
 * @returns {string|null} - The vehicle ID or null if not found
 */
export const getVehicleId = (
  vehicle: VehicleInfo | undefined
): string | null => {
  if (
    vehicle &&
    Array.isArray(vehicle.crossRef) &&
    vehicle.crossRef.length > 0
  ) {
    return vehicle.crossRef[0]?.crossRef || null;
  }
  return null;
};

/**
 * Interface for location-like objects with search parameters
 */
export interface LocationLike {
  search: string;
}

/**
 * Parses URL query parameters
 * @param {LocationLike} location - Location object with search parameters
 * @returns {Record<string, string>} - Object containing all parsed parameters
 */
export const parseQueryString = (
  location: LocationLike
): Record<string, string> => {
  const searchParams = new URLSearchParams(location.search);
  const params: Record<string, string> = {};
  for (const [key, value] of Array.from(searchParams.entries())) {
    params[key] = value;
  }
  return params;
};
